exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-images-2 {\n  margin: -255px 80px 50px;\n}\n.container {\n  margin: 0 auto;\n}\n.content-text {\n  font-weight: bold;\n  font-size: 16px;\n  padding: 20px;\n}\n.content-box {\n  text-align: center;\n  margin-left: 15px;\n}\n.otpBox {\n  width: 250px;\n  margin: 0 auto;\n  margin-top: 150px;\n  padding: 20px;\n  background: #f5f5f5;\n  border: 1px solid #d4d4d4;\n  height: 150px;\n}\n\np{\n  text-align: center;\n}\n.btn{\n  height: auto;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/admin/qrcode/batchstamp/linkSaleout/linkSaleout.component.css
// module id = ../../../../../src/app/pages/admin/qrcode/batchstamp/linkSaleout/linkSaleout.component.css
// module chunks = 3